module.exports = __webpack_public_path__ + "static/media/ola_2.d06fad7a.jpg";